module.exports = "<div class=\"alert alert-warning\" role=\"alert\">\n  <h4><span class=\"glyphicon glyphicon-alert\"></span> Внимание! Страница не найдена!</h4>\n  \n  <br>\n  Перейти на <a routerLink=\"\" routerLinkActive=\"active\">Главную</a>\n</div>"


//////////////////
// WEBPACK FOOTER
// /usr/home/rob/Staxi/client/src/app/page-not-found/page-not-found.component.html
// module id = ../../../../../src/app/page-not-found/page-not-found.component.html
// module chunks = main